(() => {
  const notification = document.querySelector('[data-discount-notification]');
  if (!notification) return;

  const storageKey = 'salt:discount-notification';
  const normalize = (code) => code.trim().toUpperCase();
  let saved = {};
  try {
    saved = JSON.parse(sessionStorage.getItem(storageKey)) || {};
  } catch (_) {
    // The notification still works when browser storage is blocked.
  }

  const queryCode = new URLSearchParams(window.location.search).get('discount');
  const queryCodes = queryCode ? queryCode.split(',').map(normalize).filter(Boolean) : [];
  const cookie = document.cookie.split('; ').find((entry) => entry.startsWith('discount_code='));
  let cookieCode = '';
  try {
    cookieCode = cookie ? decodeURIComponent(cookie.slice('discount_code='.length)) : '';
  } catch (_) {
    // A malformed cookie must not interrupt the storefront.
  }

  // Shopify's /discount/CODE redirect leaves the code in this cookie.
  const codes = queryCodes.length ? queryCodes : cookieCode.split(',').map(normalize).filter(Boolean);
  if (!codes.length) return;
  const shown = new Set(Array.isArray(saved.shown) ? saved.shown : []);
  let internalNavigation = false;
  try {
    internalNavigation = new URL(document.referrer).origin === window.location.origin;
  } catch (_) {
    // Direct entries have no referrer.
  }
  const linkEntry = queryCodes.length > 0 || !internalNavigation;
  const received = linkEntry ? codes : codes.filter((code) => !shown.has(code));

  if (received.length) {
    const message = notification.querySelector('[data-discount-message]');
    const status = document.querySelector('[data-discount-status]');
    const text = notification.dataset.message.replace('[discount]', received.join(', '));
    const [before, after = ''] = notification.dataset.message.split('[discount]');
    const code = document.createElement('strong');
    code.className = 'discount-notification__code';
    code.textContent = received.join(', ');
    message.replaceChildren(before, code, after);
    status.textContent = text;
    notification.hidden = false;

    const configuredDuration = Number(notification.dataset.duration);
    const duration = Number.isFinite(configuredDuration) && configuredDuration >= 3 && configuredDuration <= 15
      ? configuredDuration * 1000
      : 6000;
    // One animation drives both the visible countdown and automatic dismissal.
    const countdown = notification.querySelector('[data-discount-progress]').animate(
      [{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }],
      { duration, easing: 'linear', fill: 'forwards' }
    );
    const dismiss = () => {
      countdown.cancel();
      notification.hidden = true;
      status.textContent = '';
    };
    const resume = () => {
      if (!notification.hidden && !notification.matches(':hover, :focus-within')) countdown.play();
    };
    countdown.onfinish = dismiss;
    notification.querySelector('[data-discount-close]').addEventListener('click', dismiss);
    notification.addEventListener('mouseenter', () => countdown.pause());
    notification.addEventListener('mouseleave', resume);
    notification.addEventListener('focusin', () => countdown.pause());
    notification.addEventListener('focusout', resume);
    notification.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') dismiss();
    });
    if (notification.matches(':hover, :focus-within')) countdown.pause();

    received.forEach((code) => shown.add(code));
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ shown: [...shown] }));
    } catch (_) {
      // Keep working without session storage.
    }
  }

  if (!queryCodes.length) return;
  let applying = false;
  let applied = false;
  const applyQueryCodes = async () => {
    if (applying || applied) return;
    applying = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const existingCodes = (cart.discount_codes || []).map((discount) => normalize(discount.code));
      if (queryCodes.some((code) => !existingCodes.includes(code))) {
        // The discount parameter replaces the entire list, so preserve existing codes.
        const mergedCodes = [...new Set([...existingCodes, ...queryCodes])];
        const update = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: mergedCodes.join(',') }),
        });
        if (!update.ok) return;
        const updatedCart = await update.json();
        applied = true;
        void publish(PUB_SUB_EVENTS.cartUpdate, { source: 'discount-notification', cartData: updatedCart }).catch(() => {});
      } else {
        applied = true;
      }
    } catch (_) {
      // Retry after the next cart update if a network request fails.
    } finally {
      applying = false;
    }
  };
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    void applyQueryCodes();
  });
  void applyQueryCodes();
})();
